<template>
  <v-flex style="overflow-x:auto">
    <table id="permissions-table">
      <thead>
        <tr>
          <th v-for="(resource, index) in features" :key="index" class="permission-label"><div>{{resource.name}}</div></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(team, teamNo) in teams" :key="teamNo">
          <slot v-for="(resource, index) in features">
            <td v-if="hasPermission(team, resource.id)" class="permission-check" :key="index"> <v-icon @click="togglePermission(team, resource.name)" color="success">check</v-icon> </td>
            <td v-if="!hasPermission(team, resource.id)" class="permission-check" :key="index"> <v-icon @click="togglePermission(team, resource.name)" color="#DB444AA1">close</v-icon> </td>
          </slot>
        </tr>
      </tbody>
    </table>
  </v-flex>
</template>

<script>
export default {
  props: { caseType: { type: Object, required: true }, teams: { type: Array, required: true } },
  computed: {
    accessId() {
      let accessId = null
      if (this.data.resources) {
        this.data.resources.forEach(function(res) {
          if (res.name === "Access") { accessId = res.id }
        })
      }
      return accessId
    },
    features() {
      const feats = []
      if (this.data.resources) {
        this.data.resources.forEach(function(res) {
          if (res.permissionType === "yes_no" && res.name !== "Export" && res.name !== "Import") { feats.push(res) }
        })
      }
      return feats
    },
    data() {
      if (this.caseType) {
        return {
          caseTypeId: this.caseType.id,
          permissions: this.caseType.permissions,
          resources: this.caseType.resources,
          accessTeams: this.caseType.teams,
          tasklists: this.caseType.tasklistTemplates
        }
      }
      return undefined
    }
  },
  methods: {
    hasPermission(team, resource) {
      if (this.data.permissions) {
        const permission = this.data.permissions.find((currentPermission) => (currentPermission.team.id === team.id && currentPermission.resource.id === resource))
        if (permission) {
          return (permission.permissionFlag === "yes")
        } else {
          return false
        }
      }
      return false
    },
    togglePermission(team, resource) {
      const permission = this.data.permissions.find((currentPermission) => (currentPermission.team.id === team.id && currentPermission.resource.name === resource))
      if (permission) {
        this.revokePermission(permission)
      } else {
        this.grantPermission({ caseTypeId: this.data.caseTypeId, teamId: team.id, resource: resource })
      }
    },
    async grantPermission(permData) {
      if (permData.resource.id === this.accessId) {
        if (!this.data.accessTeams.includes(permData.team.id)) { this.data.accessTeams.push(permData.team.id) }
      }
      const newPermission = await this.$store.dispatch("grantPermission", permData)
      this.data.permissions.push(newPermission)
    },
    async revokePermission(permData) {
      permData.caseTypeId = this.data.caseTypeId
      const response = await this.$store.dispatch("revokePermission", permData)
      if (response && !response.error) {
        if (permData.resource.id === this.accessId) {
          this.data.accessTeams.splice(this.data.accessTeams.indexOf(permData.team.id), 1)
        }
        const index = this.data.permissions.indexOf(permData)
        if (index >= 0) this.data.permissions.splice(index, 1)
      }
    }
  }
}
</script>
